import { a as attachProps, P as PuxFooter, b as PuxButton, c as PuxDialogTitle, d as PuxModalContent, e as PuxSheet, f as PuxLifeCycleContext, g as PuxRouterOutletInner, S as StackContext, N as NavContext, h as createForwardRef, i as PuxTabBar, j as PageManager, D as DefaultPuxLifeCycleContext } from './PuxItem-89181e03.esm.js';
export { D as DefaultPuxLifeCycleContext, N as NavContext, k as PuxAccordian, l as PuxAccordianPanel, m as PuxActionButton, n as PuxApp, o as PuxAvatar, ax as PuxBackButton, p as PuxBackdrop, q as PuxBadge, b as PuxButton, r as PuxButtons, s as PuxCard, t as PuxCardContent, u as PuxCardHeader, v as PuxCardSubtitle, w as PuxCardTitle, x as PuxChart, y as PuxCheckbox, z as PuxChip, A as PuxCol, B as PuxContent, C as PuxDatetime, c as PuxDialogTitle, E as PuxDropdown, F as PuxFab, G as PuxFabButton, H as PuxFabList, P as PuxFooter, I as PuxGauge, J as PuxGrid, K as PuxHeader, at as PuxIcon, L as PuxImg, M as PuxInfiniteScroll, O as PuxInfiniteScrollContent, Q as PuxInput, ay as PuxItem, R as PuxItemDivider, T as PuxItemGroup, U as PuxLabel, f as PuxLifeCycleContext, V as PuxList, W as PuxListHeader, au as PuxLogo, X as PuxMenu, Y as PuxMenuButton, Z as PuxMenuToggle, d as PuxModalContent, _ as PuxNav, $ as PuxNavlinks, a0 as PuxNote, av as PuxPage, a1 as PuxPageOutlet, a2 as PuxProgressBar, a3 as PuxRadio, a4 as PuxRadioGroup, a5 as PuxRange, a6 as PuxRefresher, a7 as PuxRefresherContent, a8 as PuxRow, a9 as PuxSearchbar, aa as PuxSegment, ab as PuxSegmentButton, ac as PuxSelect, ad as PuxSelectOption, ae as PuxSelectPopover, e as PuxSheet, af as PuxSimcard, ag as PuxSkeletonText, ah as PuxSlide, ai as PuxSlides, aj as PuxSpinner, ak as PuxSplitPane, i as PuxTabBar, aw as PuxTabButton, al as PuxTable, am as PuxText, an as PuxTextarea, ao as PuxThumbnail, ap as PuxTitle, aq as PuxToggle, ar as PuxToolbar, as as PuxVirtualScroll, S as StackContext } from './PuxItem-89181e03.esm.js';
import { actionSheetController as actionSheetController$1, alertController, toastController as toastController$1, modalController, popoverController, loadingController, mediaQueries, orderedMediaQueries, mediaQuerySizeToString, componentMap, createTypographyClasses, menuController } from '@phonero/pux-core';
import * as React from 'react';
import React__default, { useState, Fragment, useContext, useRef, useMemo, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useMediaQuery } from 'react-responsive';
import { objectKeys } from 'simplytyped';
import { useHistory } from 'react-router';
import i18n from 'i18next';
import { initReactI18next, getI18n, useTranslation } from 'react-i18next';
export { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import { createRoot } from 'react-dom/client';
import '@phonero/pux-core/loader';
import '@phonero/pux-icons/loader';
import '@phonero/pux-logos/loader';

var __awaiter$5 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest$b = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const createOverlayComponent = (displayName, controller) => {
    const didDismissEventName = `on${displayName}DidDismiss`;
    const didPresentEventName = `on${displayName}DidPresent`;
    const willDismissEventName = `on${displayName}WillDismiss`;
    const willPresentEventName = `on${displayName}WillPresent`;
    class Overlay extends React__default.Component {
        constructor(props) {
            super(props);
            if (typeof document !== "undefined") {
                this.el = document.createElement("div");
            }
            this.handleDismiss = this.handleDismiss.bind(this);
        }
        static get displayName() {
            return displayName;
        }
        componentDidMount() {
            if (this.props.isOpen) {
                this.present();
            }
        }
        componentWillUnmount() {
            if (this.overlay) {
                this.overlay.dismiss();
            }
        }
        handleDismiss(event) {
            if (this.props.onDidDismiss) {
                this.props.onDidDismiss(event);
            }
            if (this.props.forwardedRef) {
                this.props.forwardedRef.current = undefined;
            }
        }
        componentDidUpdate(prevProps) {
            return __awaiter$5(this, void 0, void 0, function* () {
                if (this.overlay) {
                    attachProps(this.overlay, this.props, prevProps);
                }
                if (prevProps.isOpen !== this.props.isOpen &&
                    this.props.isOpen === true) {
                    this.present(prevProps);
                }
                if (this.overlay &&
                    prevProps.isOpen !== this.props.isOpen &&
                    this.props.isOpen === false) {
                    yield this.overlay.dismiss();
                }
            });
        }
        present(prevProps) {
            return __awaiter$5(this, void 0, void 0, function* () {
                const _a = this.props, cProps = __rest$b(_a, ["children", "isOpen", "onDidDismiss", "onDidPresent", "onWillDismiss", "onWillPresent"]);
                const elementProps = Object.assign(Object.assign({}, cProps), { ref: this.props.forwardedRef, [didDismissEventName]: this.handleDismiss, [didPresentEventName]: (e) => this.props.onDidPresent && this.props.onDidPresent(e), [willDismissEventName]: (e) => this.props.onWillDismiss && this.props.onWillDismiss(e), [willPresentEventName]: (e) => this.props.onWillPresent && this.props.onWillPresent(e) });
                this.overlay = yield controller.create(Object.assign(Object.assign({}, elementProps), { component: this.el, componentProps: {} }));
                if (this.props.forwardedRef) {
                    this.props.forwardedRef.current = this.overlay;
                }
                attachProps(this.overlay, elementProps, prevProps);
                yield this.overlay.present();
            });
        }
        render() {
            return ReactDOM.createPortal(this.props.isOpen ? this.props.children : null, this.el);
        }
    }
    return React__default.forwardRef((props, ref) => {
        return React__default.createElement(Overlay, Object.assign({}, props, { forwardedRef: ref }));
    });
};

const actionSheetController = {
    create: (options) => actionSheetController$1.create(options),
    dismiss: (data, role, id) => actionSheetController$1.dismiss(data, role, id),
    getTop: () => actionSheetController$1.getTop(),
};
const PuxActionSheet = /*@__PURE__*/ createOverlayComponent("PuxActionSheet", actionSheetController);

var __awaiter$4 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest$a = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const createControllerComponent = (displayName, controller) => {
    const didDismissEventName = `on${displayName}DidDismiss`;
    const didPresentEventName = `on${displayName}DidPresent`;
    const willDismissEventName = `on${displayName}WillDismiss`;
    const willPresentEventName = `on${displayName}WillPresent`;
    class Overlay extends React__default.Component {
        constructor(props) {
            super(props);
            this.isUnmounted = false;
            this.handleDismiss = this.handleDismiss.bind(this);
        }
        static get displayName() {
            return displayName;
        }
        componentDidMount() {
            return __awaiter$4(this, void 0, void 0, function* () {
                const { isOpen } = this.props;
                if (isOpen) {
                    this.present();
                }
            });
        }
        componentWillUnmount() {
            this.isUnmounted = true;
            if (this.overlay) {
                this.overlay.dismiss();
            }
        }
        componentDidUpdate(prevProps) {
            return __awaiter$4(this, void 0, void 0, function* () {
                if (prevProps.isOpen !== this.props.isOpen &&
                    this.props.isOpen === true) {
                    this.present(prevProps);
                }
                if (this.overlay &&
                    prevProps.isOpen !== this.props.isOpen &&
                    this.props.isOpen === false) {
                    yield this.overlay.dismiss();
                }
            });
        }
        handleDismiss(event) {
            if (this.props.onDidDismiss) {
                this.props.onDidDismiss(event);
            }
            if (this.props.forwardedRef) {
                this.props.forwardedRef.current = undefined;
            }
        }
        present(prevProps) {
            return __awaiter$4(this, void 0, void 0, function* () {
                const _a = this.props, cProps = __rest$a(_a, ["isOpen", "onDidDismiss", "onDidPresent", "onWillDismiss", "onWillPresent"]);
                this.overlay = yield controller.create(Object.assign({}, cProps));
                attachProps(this.overlay, {
                    [didDismissEventName]: this.handleDismiss,
                    [didPresentEventName]: (e) => this.props.onDidPresent && this.props.onDidPresent(e),
                    [willDismissEventName]: (e) => this.props.onWillDismiss && this.props.onWillDismiss(e),
                    [willPresentEventName]: (e) => this.props.onWillPresent && this.props.onWillPresent(e),
                }, prevProps);
                // Check isOpen again since the value could have changed during the async call to controller.create
                // It's also possible for the component to have become unmounted.
                if (this.props.isOpen === true && this.isUnmounted === false) {
                    if (this.props.forwardedRef) {
                        this.props.forwardedRef.current = this.overlay;
                    }
                    yield this.overlay.present();
                }
            });
        }
        render() {
            return null;
        }
    }
    return React__default.forwardRef((props, ref) => {
        return React__default.createElement(Overlay, Object.assign({}, props, { forwardedRef: ref }));
    });
};

const PuxAlert = /*@__PURE__*/ createControllerComponent("PuxAlert", alertController);

const toastController = {
    create: (options) => toastController$1.create(options),
    dismiss: (data, role, id) => toastController$1.dismiss(data, role, id),
    getTop: () => toastController$1.getTop(),
};
const PuxToast = /*@__PURE__*/ createControllerComponent("PuxToast", toastController);

const puxGlobalEventName = "pux-global-toaster";
const pushToast = (options) => {
    const e = new CustomEvent(puxGlobalEventName, {
        detail: options,
    });
    document.dispatchEvent(e);
    return e;
};
const toastFactory = (color) => {
    return (message, options //  Omit<Partial<ToastArgs>, 'message' | 'color'>
    ) => pushToast(Object.assign(Object.assign({}, options), { message, color }));
};
const toaster = {
    error: toastFactory("danger"),
    success: toastFactory("success"),
};

var __awaiter$3 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest$9 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** A global Toast-message-handler, for use alongWith pushToast
 *
 * supports stacking of toasts
 *
 * */
function PuxToastGlobal({ 
/** The max-limit for how many items that can be queued in total */
maxItems = 30, maxStackable = 4, defaults = { position: "bottom", duration: 8000 }, }) {
    let defaultPosition = defaults.position || "bottom";
    const [toastMap, setToastMap] = useState({ bottom: {}, top: {}, middle: {} });
    if (!toastMap[defaultPosition]) {
        if (process.env.NODE_ENV === "development") {
            throw new Error(`Received non-supported position '${defaultPosition}' for toast. Using default-value.`);
        }
        defaultPosition = "bottom";
    }
    React__default.useEffect(() => {
        function handler({ detail: toast }) {
            if (toast) {
                let position = toast.position || defaultPosition;
                if (!toastMap[position]) {
                    if (process.env.NODE_ENV === "development") {
                        throw new Error(`Received non-supported position '${position}' for toast. Using default-value.`);
                    }
                    position = defaultPosition;
                }
                let key = toast.key || toast.message.toString();
                if (!key) {
                    key = new Date().getTime().toString();
                }
                if (Object.keys(toastMap[position]).length > maxItems) {
                    key = "__max_limit_reached";
                }
                setToastMap((s) => (Object.assign(Object.assign({}, s), { [position]: Object.assign(Object.assign({}, s[position]), { [key]: Object.assign({ isOpen: !!toast.message, key }, toast) }) })));
            }
        }
        document.addEventListener(puxGlobalEventName, handler);
        return () => {
            document.removeEventListener(puxGlobalEventName, handler);
        };
    });
    // TODO: Fix the hacky implementation of offsetting elements
    return (React__default.createElement(React__default.Fragment, null, Object.keys(toastMap).map((position) => {
        const toasts = Object.values(toastMap[position]);
        return (React__default.createElement(React__default.Fragment, { key: position }, toasts.slice(0, maxStackable).map((toast, i) => {
            const dir = position === "top" ? 1 : -1;
            if (toast.ref) {
                offsetElement(toast.ref, 0, i * h * dir);
            }
            return (React__default.createElement(PuxToast, Object.assign({}, defaults, toast, { duration: 3000, onWillPresent: (e) => __awaiter$3(this, void 0, void 0, function* () {
                    const div = e.target;
                    setToastMap((s) => (Object.assign(Object.assign({}, s), { [position]: Object.assign(Object.assign({}, s[position]), { [toast.key]: Object.assign(Object.assign({}, s[position][toast.key]), { ref: div }) }) })));
                    !!i && offsetElement(div, 0, i * h * dir);
                    toast.onWillPresent && toast.onWillPresent(e);
                }), onWillDismiss: (e) => {
                    offsetElement(e.target, 0, -parseInt(e.target.style.marginTop) / h);
                    toast.onWillDismiss && toast.onWillDismiss(e);
                }, onDidDismiss: (e) => {
                    setToastMap((s) => {
                        const _a = s[position], _b = toast.key; _a[_b]; const rest = __rest$9(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                        return Object.assign(Object.assign({}, s), { [position]: rest });
                    });
                    toast.onDidDismiss && toast.onDidDismiss(e);
                } })));
        })));
    })));
}
const h = 58;
function offsetElement(el, _x, y) {
    el.style.marginTop = `${y}px`;
    el.style.transition = "margin 150ms";
}

const PuxModal = /*@__PURE__*/ createOverlayComponent("PuxModal", modalController);

const PuxPopover = /*@__PURE__*/ createOverlayComponent("PuxPopover", popoverController);

const PuxLoading = /*@__PURE__*/ createControllerComponent("PuxLoading", loadingController);

class PuxErrorBoundary extends React__default.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        const type = error.constructor.name;
        const message = error.message;
        return { hasError: true, type, message, error };
    }
    componentDidCatch(error, _errorInfo) {
        // Catch errors in any components below and re-render with error message
        console === null || console === void 0 ? void 0 : console.error(error);
    }
    componentDidUpdate(prevProps, prevState, _snapshot) {
        // Reset error state
        if (prevProps.children !== this.props.children && prevState.hasError) {
            this.setState({ hasError: false });
        }
    }
    render() {
        const { hasError } = this.state;
        const { children, component } = this.props;
        if (!hasError)
            return children;
        const ErrorComponent = component;
        return React__default.createElement(ErrorComponent, Object.assign({}, this.state));
    }
}

var __rest$8 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
function getIsOpen(loc, location) {
    switch (true) {
        case !!loc.hash:
            return location.hash === loc.hash;
        case !!loc.pathname:
            return location.pathname === loc.pathname;
        case !!loc.search:
            return location.search === loc.search;
    }
    return false;
}
/** @deprecated in the future PUX will remove the dependency on react-router */
function usePuxLocationAwereness(props) {
    const history = useHistory();
    const onClose = () => {
        var _a;
        // history.goBack often acts quite buggy. Unless we track the users current history, we should probably just use history.push
        switch (true) {
            case !!props.hash:
                history.push(history.location.pathname);
                break;
            default:
                history.goBack();
                break;
        }
        (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    const isOpen = getIsOpen(props, history.location);
    return { isOpen, onClose };
}
/** @deprecated in the future PUX will remove the dependency on react-router */
function PuxModalLocation(_a) {
    var { onDidDismiss } = _a, props = __rest$8(_a, ["onDidDismiss"]);
    const { isOpen, onClose } = usePuxLocationAwereness(props);
    return (React.createElement(PuxModal, Object.assign({ keyboardClose: true, swipeToClose: true, isOpen: isOpen, onDidDismiss: onDidDismiss || onClose }, props)));
}

/** useBreakpoints is a wrapper around useMediaQuery with presets for both min and max-values
 *
 *
 * These are the current min-sizes for each:
 *
 * | name | width  | description  |
 * | ---  | ---    | ---         |
 * | xs |  0       | Extra Small  |
 * | s  |  375  px | Small, Regular Cellulars like iPhone 6/7/8/X/XS and below        |
 * | sm |  576  px | Small-medium, Big Cellulars like iPhone Pro |
 * | md |  768  px | Medium, Typical Pad-size       |
 * | lg |  992  px | Large, Big Pads / Desktop        |
 * | xl |  1200 px | Extra Extra Desktop breakpoint.  |
 *
 * Note that you can set options to use the min- and max-size. This lets you control both ends.
 * Max is calculated by using the next size up minus a pixel.
 *
 * By default, only min is used.
 *
 * @example
 *
 * const smFloor = useBreakpoints('sm')
 * // min-width: 576px
 * const smContained = useBreakpoints('sm', {useMax: true})
 * // min-width: 576px, max-width: 767px
 * const smCeil = useBreakpoints('sm', {useMax: true, useMin: false})
 * // max-width: 767px
 */
const useBreakpoint = (name, { useMax = false, useMin = true } = {}) => {
    const current = mediaQueries[name];
    if (!current) {
        throw new Error(`Could not find the breakpoint '${name}'`);
    }
    const currentIndex = orderedMediaQueries.indexOf(current);
    const next = orderedMediaQueries[currentIndex + 1];
    const max = (current === null || current === void 0 ? void 0 : current.maxWidth) || (next === null || next === void 0 ? void 0 : next.minWidth) || current.minWidth + 1000;
    if (useMax && !max) {
        throw new Error(`Could not resolve the max-value for breakpoint '${name}'`);
    }
    const bp = Object.assign(Object.assign({}, (useMin && { minWidth: current.minWidth })), (useMax && { maxWidth: max }));
    return useMediaQuery({
        query: mediaQuerySizeToString(bp),
    });
};
/*
  @deprecated. Please use singular-version @see useBreakpoint

  Do not change min/max props at runtime, it will mix up the code


*/
const useBreakpoints = () => {
    const min = objectKeys(mediaQueries).reduce((r, key) => {
        const q = mediaQueries[key];
        // Why it is ok to ignore this rules-of-hook:
        // The keys are generated in the same order every time, so react will still be able to track them.
        // there is no conditional here.
        // However, if min or max-props change at runtime, things will crash.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        r[key] = useMediaQuery({ query: mediaQuerySizeToString(q) });
        return r;
    }, {});
    const max = objectKeys(mediaQueries).reduce((r, key) => {
        const q = mediaQueries[key];
        const qs = {
            maxWidth: q.maxWidth || q.minWidth - 1,
        };
        // Why it is ok to ignore this rules-of-hook:
        // The keys are generated in the same order every time, so react will still be able to track them.
        // there is no conditional here.
        // However, if min or max-props change at runtime, things will crash.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        r[key] = useMediaQuery({ query: mediaQuerySizeToString(qs) });
        return r;
    }, {});
    return { min, max };
};

var __rest$7 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
function PuxModalFooter(_a) {
    var { children } = _a, props = __rest$7(_a, ["children"]);
    const md = useBreakpoint("md");
    return (React.createElement(PuxFooter, Object.assign({ shadow: true }, props),
        React.createElement("div", { style: {
                minHeight: md ? "8.5rem" : 60,
                padding: "12px 50px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            } }, children)));
}

function PuxModalButton(props) {
    return React.createElement(PuxButton, Object.assign({}, props));
}

var __rest$6 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
function PuxDialogue(props) {
    if ("hash" in props ||
        "state" in props ||
        "search" in props ||
        "pathname" in props) {
        //!nocommit
        return React.createElement(PuxDialogueLocationAware, Object.assign({}, props));
    }
    if ("isOpen" in props) {
        return React.createElement(PuxDialogue2, Object.assign({}, props));
    }
    throw new Error("Got unexpected props to PuxDialogue");
}
function PuxDialogue2(_a) {
    var { titleProps, footerProps, footer, children, title, withBackButton, contentWrapperMode = "default", sheetProps } = _a, props = __rest$6(_a, ["titleProps", "footerProps", "footer", "children", "title", "withBackButton", "contentWrapperMode", "sheetProps"]);
    return (React.createElement(PuxModal, Object.assign({ keyboardClose: true, swipeToClose: true }, props),
        React.createElement(PuxDialogTitle, { withBackButton: withBackButton }, title),
        contentWrapperMode === undefined || contentWrapperMode === "default" ? (React.createElement(PuxModalContent, null,
            React.createElement(PuxSheet, Object.assign({}, sheetProps), children))) : contentWrapperMode === "slimSheet" ? (React.createElement(PuxModalContent, null,
            React.createElement(PuxSheet, Object.assign({}, sheetProps, { noGutter: true, noPadding: true }), children))) : contentWrapperMode === "slim" ? (React.createElement(PuxModalContent, null,
            " ",
            children,
            " ")) : (children),
        (!!footer || footerProps) && (React.createElement(PuxModalFooter, Object.assign({}, footerProps), footer))));
}
/** @deprecated in the future PUX will remove the dependency on react-router */
function PuxDialogueLocationAware(_a) {
    var { onDidDismiss } = _a, props = __rest$6(_a, ["onDidDismiss"]);
    const { isOpen, onClose } = usePuxLocationAwereness(props);
    return (React.createElement(PuxDialogue2, Object.assign({ keyboardClose: true, swipeToClose: true, isOpen: isOpen, onDidDismiss: onDidDismiss || onClose }, props)));
}

var DateFormat;
(function (DateFormat) {
    /** Date and time */
    DateFormat["DateTime"] = "dateTime";
    DateFormat["DateTimeLong"] = "dateTimeLong";
    /** Time only */
    DateFormat["Time"] = "time";
    /** Date only */
    DateFormat["Date"] = "date";
    DateFormat["DateLong"] = "dateLong";
    DateFormat["MonthNameShort"] = "monthShort";
    DateFormat["MonthNameLong"] = "monthLong";
    DateFormat["MonthAndYearLong"] = "monthYearLong";
    DateFormat["MonthAndYearShort"] = "monthYearShort";
    DateFormat["RelativeDate"] = "relativeDate";
})(DateFormat || (DateFormat = {}));
var PriceFormat;
(function (PriceFormat) {
    PriceFormat["Default"] = "0,0.00.-";
})(PriceFormat || (PriceFormat = {}));
var ByteFormat;
(function (ByteFormat) {
    ByteFormat["Default"] = "0.0GB";
})(ByteFormat || (ByteFormat = {}));

/**
 * Formats the current date into common formats.
 *
 *  Option to include timezone, then the output is according to the given timezone.
 *
 *  Local San Francisco time 2024-10-31T17:00:00-07:00 becomes 'oktober 2024' (local time) but 'november 2024' in Oslo time ("Europe/Oslo").
 *
 * **/
const formatDate = (value, format, locale, timeZone) => {
    if (options.IntlOptions.formatterFunc) {
        const result = options.IntlOptions.formatterFunc(value, format, locale);
        // Returning an empty string should be allowed, but undefined and null
        // is interpreted as 'contunue to regular formatter'
        if (result !== undefined && result !== null) {
            return result;
        }
    }
    if (!value) {
        return "";
    }
    if (typeof Intl !== "object") {
        // Fallback for older browsers.
        return value.toLocaleString();
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
        return null;
    }
    if (format && typeof format === "object") {
        return Intl.DateTimeFormat(getIntlLocale(), format).format(date);
    }
    const loc = getIntlLocale(locale);
    switch (format) {
        case DateFormat.RelativeDate:
            const difference = date.getTime() - Date.now();
            let totalDays = Math.ceil(difference / (1000 * 3600 * 24));
            return ((Math.abs(totalDays) < 2
                ? new Intl.RelativeTimeFormat(loc, { numeric: "auto" }).format(totalDays, "day") + ", "
                : "") +
                Intl.DateTimeFormat(loc, {
                    day: "2-digit",
                    month: "long",
                    year: numeric,
                }).format(date));
        case DateFormat.DateTime:
            return Intl.DateTimeFormat(loc, Object.assign({ minute: numeric, hour: numeric, day: "2-digit", month: "2-digit", year: numeric }, timeZone && { timeZone })).format(date);
        case DateFormat.MonthAndYearLong:
            return Intl.DateTimeFormat(loc, Object.assign({ month: "long", year: numeric }, timeZone && { timeZone })).format(date);
        case DateFormat.MonthAndYearShort:
            return Intl.DateTimeFormat(loc, Object.assign({ month: "short", year: numeric }, timeZone && { timeZone })).format(date);
        case DateFormat.Time:
        case "hh:mm":
            return Intl.DateTimeFormat(loc, Object.assign({ minute: numeric, hour: numeric }, timeZone && { timeZone })).format(date);
        case DateFormat.Date:
            return Intl.DateTimeFormat(loc, Object.assign({ day: "2-digit", month: "2-digit", year: numeric }, timeZone && { timeZone })).format(date);
        case DateFormat.MonthNameLong:
            return Intl.DateTimeFormat(loc, Object.assign({ month: "long" }, timeZone && { timeZone })).format(date);
        case DateFormat.MonthNameShort:
            return Intl.DateTimeFormat(loc, Object.assign({ month: "short" }, timeZone && { timeZone })).format(date);
        case "LL":
        case DateFormat.DateLong:
            return Intl.DateTimeFormat(loc, Object.assign({ day: numeric, month: "long", year: numeric }, timeZone && { timeZone })).format(date);
        case DateFormat.DateTimeLong:
            return Intl.DateTimeFormat(loc, Object.assign({ day: numeric, month: "long", year: numeric, minute: numeric, hour: numeric }, timeZone && { timeZone })).format(date);
        default:
            // shim for common momentjs formats, for backward compatibility
            if (typeof format === "string" && format !== "") {
                console.warn("Deprecated dateTimeformat. The format will be shimmed.", {
                    loc,
                    format,
                    date,
                });
                const YYYY = date.getUTCFullYear();
                const MM = (date.getUTCMonth() + 1).toString().padStart(2, "0");
                const MMM = Intl.DateTimeFormat(loc, { month: "short" }).format(date);
                const MMMM = Intl.DateTimeFormat(loc, { month: "long" }).format(date);
                const dddd = Intl.DateTimeFormat(loc, { weekday: "long" }).format(date);
                return format
                    .replace(/dddd/g, dddd)
                    .replace(/MMMM/g, MMMM)
                    .replace(/MMM/g, MMM)
                    .replace(/MM/g, MM)
                    .replace(/YYYY/gi, String(YYYY))
                    .replace(/Do/g, numberOrdinals(date.getDate(), loc))
                    .replace(/hh/gi, date.getHours().toString().padStart(2, "0"))
                    .replace(/mm/gi, date.getMinutes().toString().padStart(2, "0"));
            }
            return Intl.DateTimeFormat(loc, options.IntlOptions.DateTimeFormat).format(date);
    }
};
/** A short version of ordinals, which usually include the number as a number, and not written out completely*/
const numberOrdinals = (n, locale) => {
    const s = String(n);
    switch (locale.toLowerCase()) {
        case "en":
        case "en-us":
        case "en-gb":
            const last = s[s.length - 1];
            switch (last) {
                case "1":
                    return n + "st";
                case "2":
                    return n + "nd";
                case "3":
                    return n + "rd";
                default:
                    return n + "th";
            }
    }
    return s;
};
const getIntlLocale = (locale) => {
    if (!locale) {
        return getIntlLocale(options.IntlOptions.IntlLocale || "default");
    }
    return locale;
};
const numeric = "numeric";
const options = {
    IntlOptions: {
        IntlLocale: "default",
        formatterFunc: undefined,
        DateTimeFormat: {
            minute: numeric,
            hour: numeric,
            day: numeric,
            month: "long",
            year: numeric,
            timeZone: "Europe/Oslo"
        },
    },
};
const setIntlOptions = (intlOptions) => {
    options.IntlOptions = Object.assign(Object.assign({}, options.IntlOptions), intlOptions);
};

/*Deprecated. Clients should initializei18n themselves */
const initializeI18n = (config) => {
    // registerNumral(numeral)
    const options = Object.assign(Object.assign({}, config), { interpolation: {
            escapeValue: false,
            format: i18nFormater({ numeralInstance: numeral }),
        } });
    i18n
        .use(initReactI18next) // passes i18n down to react-i18next
        .init(options);
    return i18n;
};
const dateRegex = /^(19|20)\d{2}-\d{2}-\d{2}.*/;
const i18nFormater = (constructorProps = {}) => (value, format, _lng) => {
    const numeralInstance = constructorProps.numeralInstance || numeral;
    try {
        switch (format) {
            case "price":
                let n = Number(value);
                if (isNaN(n)) {
                    n = 0;
                }
                return numeralInstance(n).format("0,0.00.-");
            default:
        }
        if (typeof Intl === "object") {
            if (value instanceof Date ||
                (typeof value === "string" && dateRegex.test(value))) {
                const date = formatDate(value, format, _lng || i18n.languages[0]);
                if (date) {
                    return date;
                }
            }
        }
        if (typeof value === "number" || !isNaN(Number(value))) {
            return numeral(value).format(format);
        }
    }
    catch (e) {
        console.error("Error formatting with locale", e, { value, format, _lng });
        return value.toString();
    }
    return value;
};

const useResourceBundles = (resources, ns = "translation") => {
    if (getI18n() === undefined) {
        throw new Error("i18next not initialized, cannot get i18n from context");
    }
    const { i18n, t } = useTranslation(ns);
    Object.keys(resources).forEach((lng) => {
        // @ts-ignore: Implicit any error
        i18n.addResourceBundle(lng, ns, resources[lng]);
    });
    return { ns, t, i18n, numeral };
};

const PuxTabsContext = React__default.createContext({
    activeTab: undefined,
    selectTab: () => false,
});

var __rest$5 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
class OutletPageManager extends React__default.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        if (this.puxRouterOutlet) {
            setTimeout(() => {
                this.context.registerPuxPage(this.puxRouterOutlet, this.props.routeInfo);
            }, 25);
            this.puxRouterOutlet.addEventListener("puxViewWillEnter", this.puxViewWillEnterHandler.bind(this));
            this.puxRouterOutlet.addEventListener("puxViewDidEnter", this.puxViewDidEnterHandler.bind(this));
            this.puxRouterOutlet.addEventListener("puxViewWillLeave", this.puxViewWillLeaveHandler.bind(this));
            this.puxRouterOutlet.addEventListener("puxViewDidLeave", this.puxViewDidLeaveHandler.bind(this));
        }
    }
    componentWillUnmount() {
        if (this.puxRouterOutlet) {
            this.puxRouterOutlet.removeEventListener("puxViewWillEnter", this.puxViewWillEnterHandler.bind(this));
            this.puxRouterOutlet.removeEventListener("puxViewDidEnter", this.puxViewDidEnterHandler.bind(this));
            this.puxRouterOutlet.removeEventListener("puxViewWillLeave", this.puxViewWillLeaveHandler.bind(this));
            this.puxRouterOutlet.removeEventListener("puxViewDidLeave", this.puxViewDidLeaveHandler.bind(this));
        }
    }
    puxViewWillEnterHandler() {
        this.puxLifeCycleContext.puxViewWillEnter();
    }
    puxViewDidEnterHandler() {
        this.puxLifeCycleContext.puxViewDidEnter();
    }
    puxViewWillLeaveHandler() {
        this.puxLifeCycleContext.puxViewWillLeave();
    }
    puxViewDidLeaveHandler() {
        this.puxLifeCycleContext.puxViewDidLeave();
    }
    render() {
        const _a = this.props, { StackManager, children, routeInfo } = _a, props = __rest$5(_a, ["StackManager", "children", "routeInfo"]);
        return (React__default.createElement(PuxLifeCycleContext.Consumer, null, (context) => {
            this.puxLifeCycleContext = context;
            return (React__default.createElement(StackManager, { routeInfo: routeInfo },
                React__default.createElement(PuxRouterOutletInner, Object.assign({ setRef: (val) => (this.puxRouterOutlet = val) }, props), children)));
        }));
    }
    static get contextType() {
        return StackContext;
    }
}
var OutletPageManager$1 = OutletPageManager;

var __rest$4 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
class PuxRouterOutletContainer extends React__default.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const StackManager = this.context.getStackManager();
        const _a = this.props, { children, forwardedRef } = _a, props = __rest$4(_a, ["children", "forwardedRef"]);
        return this.context.hasPuxRouter() ? (props.puxPage ? (React__default.createElement(OutletPageManager$1, Object.assign({ StackManager: StackManager, routeInfo: this.context.routeInfo }, props), children)) : (React__default.createElement(StackManager, { routeInfo: this.context.routeInfo },
            React__default.createElement(PuxRouterOutletInner, Object.assign({}, props, { forwardedRef: forwardedRef }), children)))) : (React__default.createElement(PuxRouterOutletInner, Object.assign({ ref: forwardedRef }, this.props), this.props.children));
    }
    static get contextType() {
        return NavContext;
    }
}
const PuxRouterOutlet = createForwardRef(PuxRouterOutletContainer, "PuxRouterOutlet");

var __rest$3 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
class PuxTabsElement extends HTMLElement {
    constructor() {
        super();
    }
}
if (window && window.customElements) {
    const element = customElements.get("pux-tabs");
    if (!element) {
        customElements.define("pux-tabs", PuxTabsElement);
    }
}
const hostStyles = {
    display: "flex",
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    contain: "layout size style",
};
const tabsInner = {
    position: "relative",
    flex: 1,
    height: "100%",
    contain: "layout size style",
};
class PuxTabs extends React__default.Component {
    constructor(props) {
        super(props);
        this.routerOutletRef = React__default.createRef();
        this.tabBarRef = React__default.createRef();
        this.puxTabContextState = {
            activeTab: undefined,
            selectTab: () => false,
        };
    }
    componentDidMount() {
        if (this.tabBarRef.current) {
            // Grab initial value
            this.puxTabContextState.activeTab = this.tabBarRef.current.state.activeTab;
            // Override method
            this.tabBarRef.current.setActiveTabOnContext = (tab) => {
                this.puxTabContextState.activeTab = tab;
            };
            this.puxTabContextState.selectTab = this.tabBarRef.current.selectTab;
        }
    }
    render() {
        let outlet;
        let tabBar;
        const children = typeof this.props.children === "function"
            ? this.props.children(this.puxTabContextState)
            : this.props.children;
        React__default.Children.forEach(children, (child) => {
            if (child == null ||
                typeof child !== "object" ||
                !child.hasOwnProperty("type")) {
                return;
            }
            if (child.type === PuxRouterOutlet || child.type.isRouterOutlet) {
                outlet = React__default.cloneElement(child, { tabs: true });
            }
            else if (child.type === Fragment &&
                child.props.children[0].type === PuxRouterOutlet) {
                outlet = child.props.children[0];
            }
            if (child.type === PuxTabBar || child.type.isTabBar) {
                const { onPuxTabsDidChange, onPuxTabsWillChange } = this.props;
                tabBar = React__default.cloneElement(child, {
                    onPuxTabsDidChange,
                    onPuxTabsWillChange,
                    ref: this.tabBarRef,
                });
            }
            else if (child.type === Fragment &&
                (child.props.children[1].type === PuxTabBar ||
                    child.props.children[1].type.isTabBar)) {
                const { onPuxTabsDidChange, onPuxTabsWillChange } = this.props;
                tabBar = React__default.cloneElement(child.props.children[1], {
                    onPuxTabsDidChange,
                    onPuxTabsWillChange,
                    ref: this.tabBarRef,
                });
            }
        });
        if (!outlet) {
            throw new Error("PuxTabs must contain an PuxRouterOutlet");
        }
        if (!tabBar) {
            throw new Error("PuxTabs needs a PuxTabBar");
        }
        const _a = this.props, { className } = _a, props = __rest$3(_a, ["className"]);
        return (React__default.createElement(PuxTabsContext.Provider, { value: this.puxTabContextState }, this.context.hasPuxRouter() ? (React__default.createElement(PageManager, Object.assign({ className: className ? `${className}` : "", routeInfo: this.context.routeInfo }, props),
            React__default.createElement("pux-tabs", { className: "pux-tabs", style: hostStyles },
                tabBar.props.slot === "top" ? tabBar : null,
                React__default.createElement("div", { style: tabsInner, className: "tabs-inner" }, outlet),
                tabBar.props.slot === "bottom" ? tabBar : null))) : (React__default.createElement("div", Object.assign({ className: className ? `${className}` : "pux-tabs" }, props, { style: hostStyles }),
            tabBar.props.slot === "top" ? tabBar : null,
            React__default.createElement("div", { style: tabsInner, className: "tabs-inner" }, outlet),
            tabBar.props.slot === "bottom" ? tabBar : null))));
    }
    static get contextType() {
        return NavContext;
    }
}

var __rest$2 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** Used to set a consistant typographic style for elements, regardless of the actual component used.
 *
 * You may also set the classes to your component manually, by using `createTypographyClasses(variant)`.
 */
const PuxTypography = (_a) => {
    var { variant, component, className } = _a, rest = __rest$2(_a, ["variant", "component", "className"]);
    const Comp = component || componentMap[variant] || "span";
    return (React.createElement(Comp, Object.assign({ className: createTypographyClasses(variant, className) || undefined }, rest)));
};

class PuxRoute extends React__default.PureComponent {
    render() {
        const PuxRouteInner = this.context.getPuxRoute();
        if (!this.context.hasPuxRouter() || !PuxRoute) {
            console.error("You either do not have an Pux Router package, or your router does not support using <PuxRoute>");
            return null;
        }
        return React__default.createElement(PuxRouteInner, Object.assign({}, this.props));
    }
    static get contextType() {
        return NavContext;
    }
}

class PuxRedirect extends React__default.PureComponent {
    render() {
        const PuxRedirectInner = this.context.getPuxRedirect();
        if (!this.context.hasPuxRouter() || !PuxRedirect) {
            console.error("You either do not have an Pux Router package, or your router does not support using <PuxRedirect>");
            return null;
        }
        return React__default.createElement(PuxRedirectInner, Object.assign({}, this.props));
    }
    static get contextType() {
        return NavContext;
    }
}

const PuxRouterContext = React__default.createContext({
    routeInfo: undefined,
    push: () => {
        throw new Error("An Pux Router is required for PuxRouterContext");
    },
    back: () => {
        throw new Error("An Pux Router is required for PuxRouterContext");
    },
    canGoBack: () => {
        throw new Error("An Pux Router is required for PuxRouterContext");
    },
    nativeBack: () => {
        throw new Error("An Pux Router is required for PuxRouterContext");
    },
});
/**
 * A hook for more direct control over routing in an Pux React applicaiton. Allows you to pass additional meta-data to the router before the call to the native router.
 */
function usePuxRouter() {
    const context = useContext(PuxRouterContext);
    return {
        back: context.back,
        push: context.push,
        goBack: context.back,
        canGoBack: context.canGoBack,
        routeInfo: context.routeInfo,
    };
}

var __awaiter$2 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
function useController(displayName, controller) {
    const overlayRef = useRef();
    const didDismissEventName = useMemo(() => `on${displayName}DidDismiss`, [displayName]);
    const didPresentEventName = useMemo(() => `on${displayName}DidPresent`, [displayName]);
    const willDismissEventName = useMemo(() => `on${displayName}WillDismiss`, [displayName]);
    const willPresentEventName = useMemo(() => `on${displayName}WillPresent`, [displayName]);
    const present = (options) => __awaiter$2(this, void 0, void 0, function* () {
        if (overlayRef.current) {
            return;
        }
        const { onDidDismiss, onWillDismiss, onDidPresent, onWillPresent } = options, rest = __rest$1(options, ["onDidDismiss", "onWillDismiss", "onDidPresent", "onWillPresent"]);
        const handleDismiss = (event) => {
            if (onDidDismiss) {
                onDidDismiss(event);
            }
            overlayRef.current = undefined;
        };
        overlayRef.current = yield controller.create(Object.assign({}, rest));
        attachProps(overlayRef.current, {
            [didDismissEventName]: handleDismiss,
            [didPresentEventName]: (e) => onDidPresent && onDidPresent(e),
            [willDismissEventName]: (e) => onWillDismiss && onWillDismiss(e),
            [willPresentEventName]: (e) => onWillPresent && onWillPresent(e),
        });
        overlayRef.current.present();
    });
    const dismiss = () => __awaiter$2(this, void 0, void 0, function* () {
        overlayRef.current && (yield overlayRef.current.dismiss());
        overlayRef.current = undefined;
    });
    return {
        present,
        dismiss,
    };
}

/**
 * A hook for presenting/dismissing an PuxActionSheet component
 * @returns Returns the present and dismiss methods in an array
 */
function usePuxActionSheet() {
    const controller = useController("PuxActionSheet", actionSheetController$1);
    function present(buttonsOrOptions, header) {
        if (Array.isArray(buttonsOrOptions)) {
            controller.present({
                buttons: buttonsOrOptions,
                header,
            });
        }
        else {
            controller.present(buttonsOrOptions);
        }
    }
    return [present, controller.dismiss];
}

/**
 * A hook for presenting/dismissing an PuxAlert component
 * @returns Returns the present and dismiss methods in an array
 */
function usePuxAlert() {
    const controller = useController("PuxAlert", alertController);
    function present(messageOrOptions, buttons) {
        if (typeof messageOrOptions === "string") {
            controller.present({
                message: messageOrOptions,
                buttons: buttons !== null && buttons !== void 0 ? buttons : [{ text: "Ok" }],
            });
        }
        else {
            controller.present(messageOrOptions);
        }
    }
    return [present, controller.dismiss];
}

/**
 * A hook for presenting/dismissing an PuxToast component
 * @returns Returns the present and dismiss methods in an array
 */
function usePuxToast() {
    const controller = useController("PuxToast", toastController$1);
    function present(messageOrOptions, duration) {
        if (typeof messageOrOptions === "string") {
            controller.present({
                message: messageOrOptions,
                duration,
            });
        }
        else {
            controller.present(messageOrOptions);
        }
    }
    return [present, controller.dismiss];
}

var __awaiter$1 = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
function useOverlay(displayName, controller, component, componentProps) {
    const overlayRef = useRef();
    const containerElRef = useRef();
    const containerRootRef = useRef();
    const didDismissEventName = useMemo(() => `on${displayName}DidDismiss`, [displayName]);
    const didPresentEventName = useMemo(() => `on${displayName}DidPresent`, [displayName]);
    const willDismissEventName = useMemo(() => `on${displayName}WillDismiss`, [displayName]);
    const willPresentEventName = useMemo(() => `on${displayName}WillPresent`, [displayName]);
    const [isOpen, setIsOpen] = useState(false);
    const [clickProps, setClickProps] = useState(null);
    useEffect(() => {
        if (!containerRootRef.current && containerElRef.current) {
            containerRootRef.current = createRoot(containerElRef.current);
        }
        if (!isOpen ||
            !component ||
            !containerElRef.current ||
            !containerRootRef.current) {
            return;
        }
        if (React__default.isValidElement(component)) {
            containerRootRef.current.render(component);
        }
        else {
            let props;
            if (typeof componentProps === "function") {
                props = componentProps({
                    overlayRef,
                    containerElRef,
                    isOpen,
                    setIsOpen,
                    dismiss: () => __awaiter$1(this, void 0, void 0, function* () {
                        overlayRef.current && (yield overlayRef.current.dismiss());
                        overlayRef.current = undefined;
                        containerElRef.current = undefined;
                    }),
                });
            }
            else {
                props = componentProps;
            }
            containerRootRef.current.render(React__default.createElement(component, Object.assign(Object.assign({}, clickProps), props)));
        }
    }, [component, isOpen, componentProps, clickProps]);
    const present = (options, props) => __awaiter$1(this, void 0, void 0, function* () {
        if (overlayRef.current) {
            return;
        }
        const { onDidDismiss, onWillDismiss, onDidPresent, onWillPresent } = options, rest = __rest(options, ["onDidDismiss", "onWillDismiss", "onDidPresent", "onWillPresent"]);
        if (typeof document !== "undefined") {
            containerElRef.current = document.createElement("div");
            containerRootRef.current = createRoot(containerElRef.current);
        }
        setIsOpen(true);
        setClickProps(props);
        overlayRef.current = yield controller.create(Object.assign(Object.assign({}, rest), { component: containerElRef.current }));
        attachProps(overlayRef.current, {
            [didDismissEventName]: handleDismiss,
            [didPresentEventName]: (e) => onDidPresent && onDidPresent(e),
            [willDismissEventName]: (e) => onWillDismiss && onWillDismiss(e),
            [willPresentEventName]: (e) => onWillPresent && onWillPresent(e),
        });
        overlayRef.current.present();
        function handleDismiss(event) {
            if (onDidDismiss) {
                onDidDismiss(event);
            }
            overlayRef.current = undefined;
            containerElRef.current = undefined;
            containerRootRef.current = undefined;
            setIsOpen(false);
        }
    });
    const dismiss = () => __awaiter$1(this, void 0, void 0, function* () {
        overlayRef.current && (yield overlayRef.current.dismiss());
        overlayRef.current = undefined;
        containerElRef.current = undefined;
        containerRootRef.current = undefined;
    });
    return {
        present,
        dismiss,
    };
}

/**
 * A hook for presenting/dismissing an PuxModal component
 * @param component The component that the modal will show. Can be a React Component, a functional component, or a JSX Element
 * @param componentProps The props that will be passed to the component, if required
 * @returns Returns the present and dismiss methods in an array
 */
function usePuxModal(component, componentProps) {
    const controller = useOverlay("PuxModal", modalController, component, componentProps);
    function present(options = {}) {
        controller.present(options);
    }
    return [present, controller.dismiss];
}

/**
 * A hook for presenting/dismissing an PuxPopover component
 * @param component The component that the popover will show. Can be a React Component, a functional component, or a JSX Element
 * @param componentProps The props that will be passed to the component, if required
 * @returns Returns the present and dismiss methods in an array
 */
function usePuxPopover(component, componentProps) {
    const controller = useOverlay("PuxPopover", popoverController, component, componentProps);
    function present(options = {}, props) {
        controller.present(options, props);
    }
    return [present, controller.dismiss];
}

/**
 * A hook for presenting/dismissing an PuxLoading component
 * @returns Returns the present and dismiss methods in an array
 */
function usePuxLoading() {
    const controller = useController("PuxLoading", loadingController);
    function present(messageOrOptions = "", duration, spinner) {
        if (typeof messageOrOptions === "string") {
            controller.present({
                message: messageOrOptions,
                duration,
                spinner: spinner !== null && spinner !== void 0 ? spinner : "lines",
            });
        }
        else {
            controller.present(messageOrOptions);
        }
    }
    return [present, controller.dismiss];
}

const RouteManagerContext = 
/*@__PURE__*/ React__default.createContext({
    addViewItem: () => undefined,
    canGoBack: () => undefined,
    clearOutlet: () => undefined,
    createViewItem: () => undefined,
    findViewItemByPathname: () => undefined,
    findLeavingViewItemByRouteInfo: () => undefined,
    findViewItemByRouteInfo: () => undefined,
    getChildrenToRender: () => undefined,
    goBack: () => undefined,
    unMountViewItem: () => undefined,
});

class ViewLifeCycleManager extends React__default.Component {
    constructor(props) {
        super(props);
        this.puxLifeCycleContext = new DefaultPuxLifeCycleContext();
        this._isMounted = false;
        this.puxLifeCycleContext.onComponentCanBeDestroyed(() => {
            if (!this.props.mount) {
                if (this._isMounted) {
                    this.setState({
                        show: false,
                    }, () => this.props.removeView());
                }
            }
        });
        this.state = {
            show: true,
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        const { show } = this.state;
        return (React__default.createElement(PuxLifeCycleContext.Provider, { value: this.puxLifeCycleContext }, show && this.props.children));
    }
}

// const RESTRICT_SIZE = 100;
class LocationHistory {
    constructor() {
        this.locationHistory = [];
        this.tabHistory = {};
    }
    add(routeInfo) {
        if (routeInfo.routeAction === "push" || routeInfo.routeAction == null) {
            this._add(routeInfo);
        }
        else if (routeInfo.routeAction === "pop") {
            this._pop(routeInfo);
        }
        else if (routeInfo.routeAction === "replace") {
            this._replace(routeInfo);
        }
        if (routeInfo.routeDirection === "root") {
            this._clear();
            this._add(routeInfo);
        }
    }
    clearTabStack(tab) {
        const routeInfos = this._getRouteInfosByKey(tab);
        if (routeInfos) {
            routeInfos.forEach((ri) => {
                this.locationHistory = this.locationHistory.filter((x) => x.id !== ri.id);
            });
            this.tabHistory[tab] = [];
        }
    }
    update(routeInfo) {
        const locationIndex = this.locationHistory.findIndex((x) => x.id === routeInfo.id);
        if (locationIndex > -1) {
            this.locationHistory.splice(locationIndex, 1, routeInfo);
        }
        const tabArray = this.tabHistory[routeInfo.tab || ""];
        if (tabArray) {
            const tabIndex = tabArray.findIndex((x) => x.id === routeInfo.id);
            if (tabIndex > -1) {
                tabArray.splice(tabIndex, 1, routeInfo);
            }
            else {
                tabArray.push(routeInfo);
            }
        }
        else if (routeInfo.tab) {
            this.tabHistory[routeInfo.tab] = [routeInfo];
        }
    }
    _add(routeInfo) {
        const routeInfos = this._getRouteInfosByKey(routeInfo.tab);
        if (routeInfos) {
            // If the latest routeInfo is the same (going back and forth between tabs), replace it
            if (this._areRoutesEqual(routeInfos[routeInfos.length - 1], routeInfo)) {
                routeInfos.pop();
            }
            routeInfos.push(routeInfo);
        }
        this.locationHistory.push(routeInfo);
    }
    _areRoutesEqual(route1, route2) {
        if (!route1 || !route2) {
            return false;
        }
        return (route1.pathname === route2.pathname && route1.search === route2.search);
    }
    _pop(routeInfo) {
        const routeInfos = this._getRouteInfosByKey(routeInfo.tab);
        if (routeInfos) {
            // Pop the previous route
            routeInfos.pop();
            // Replace the current route with an updated version
            routeInfos.pop();
            routeInfos.push(routeInfo);
        }
        // Pop the previous route
        this.locationHistory.pop();
        // Replace the current route with an updated version
        this.locationHistory.pop();
        this.locationHistory.push(routeInfo);
    }
    _replace(routeInfo) {
        const routeInfos = this._getRouteInfosByKey(routeInfo.tab);
        routeInfos && routeInfos.pop();
        this.locationHistory.pop();
        this._add(routeInfo);
    }
    _clear() {
        const keys = Object.keys(this.tabHistory);
        keys.forEach((k) => (this.tabHistory[k] = []));
        this.locationHistory = [];
    }
    _getRouteInfosByKey(key) {
        let routeInfos;
        if (key) {
            routeInfos = this.tabHistory[key];
            if (!routeInfos) {
                routeInfos = this.tabHistory[key] = [];
            }
        }
        return routeInfos;
    }
    getFirstRouteInfoForTab(tab) {
        const routeInfos = this._getRouteInfosByKey(tab);
        if (routeInfos) {
            return routeInfos[0];
        }
        return undefined;
    }
    getCurrentRouteInfoForTab(tab) {
        const routeInfos = this._getRouteInfosByKey(tab);
        if (routeInfos) {
            return routeInfos[routeInfos.length - 1];
        }
        return undefined;
    }
    findLastLocation(routeInfo) {
        const routeInfos = this._getRouteInfosByKey(routeInfo.tab);
        if (routeInfos) {
            for (let i = routeInfos.length - 2; i >= 0; i--) {
                const ri = routeInfos[i];
                if (ri) {
                    if (ri.pathname === routeInfo.pushedByRoute) {
                        return ri;
                    }
                }
            }
        }
        for (let i = this.locationHistory.length - 2; i >= 0; i--) {
            const ri = this.locationHistory[i];
            if (ri) {
                if (ri.pathname === routeInfo.pushedByRoute) {
                    return ri;
                }
            }
        }
        return undefined;
    }
    previous() {
        return (this.locationHistory[this.locationHistory.length - 2] ||
            this.locationHistory[this.locationHistory.length - 1]);
    }
    current() {
        return this.locationHistory[this.locationHistory.length - 1];
    }
    canGoBack() {
        return this.locationHistory.length > 1;
    }
}

class NavManager extends React__default.PureComponent {
    constructor(props) {
        super(props);
        this.puxRouterContextValue = {
            push: (pathname, routerDirection, routeAction, routerOptions, animationBuilder) => {
                this.navigate(pathname, routerDirection, routeAction, animationBuilder, routerOptions);
            },
            back: (animationBuilder) => {
                this.goBack(undefined, animationBuilder);
            },
            canGoBack: () => this.props.locationHistory.canGoBack(),
            nativeBack: () => this.props.onNativeBack(),
            routeInfo: this.props.routeInfo,
        };
        this.state = {
            goBack: this.goBack.bind(this),
            hasPuxRouter: () => true,
            navigate: this.navigate.bind(this),
            getPuxRedirect: this.getPuxRedirect.bind(this),
            getPuxRoute: this.getPuxRoute.bind(this),
            getStackManager: this.getStackManager.bind(this),
            getPageManager: this.getPageManager.bind(this),
            routeInfo: this.props.routeInfo,
            setCurrentTab: this.props.onSetCurrentTab,
            changeTab: this.props.onChangeTab,
            resetTab: this.props.onResetTab,
        };
        if (typeof document !== "undefined") {
            document.addEventListener("puxBackButton", (e) => {
                e.detail.register(0, (processNextHandler) => {
                    this.nativeGoBack();
                    processNextHandler();
                });
            });
        }
    }
    goBack(route, animationBuilder) {
        this.props.onNavigateBack(route, animationBuilder);
    }
    nativeGoBack() {
        this.props.onNativeBack();
    }
    navigate(path, direction = "forward", action = "push", animationBuilder, options, tab) {
        this.props.onNavigate(path, action, direction, animationBuilder, options, tab);
    }
    getPageManager() {
        return PageManager;
    }
    getPuxRedirect() {
        return this.props.puxRedirect;
    }
    getPuxRoute() {
        return this.props.puxRoute;
    }
    getStackManager() {
        return this.props.stackManager;
    }
    render() {
        return (React__default.createElement(NavContext.Provider, { value: Object.assign(Object.assign({}, this.state), { routeInfo: this.props.routeInfo }) },
            React__default.createElement(PuxRouterContext.Provider, { value: Object.assign(Object.assign({}, this.puxRouterContextValue), { routeInfo: this.props.routeInfo }) }, this.props.children)));
    }
}

class ViewStacks {
    constructor() {
        this.viewStacks = {};
        this.add = this.add.bind(this);
        this.clear = this.clear.bind(this);
        this.getViewItemsForOutlet = this.getViewItemsForOutlet.bind(this);
        this.remove = this.remove.bind(this);
    }
    add(viewItem) {
        const { outletId } = viewItem;
        if (!this.viewStacks[outletId]) {
            this.viewStacks[outletId] = [viewItem];
        }
        else {
            this.viewStacks[outletId].push(viewItem);
        }
    }
    clear(outletId) {
        // Give some time for the leaving views to transition before removing
        setTimeout(() => {
            delete this.viewStacks[outletId];
        }, 500);
    }
    getViewItemsForOutlet(outletId) {
        return this.viewStacks[outletId] || [];
    }
    remove(viewItem) {
        const { outletId } = viewItem;
        const viewStack = this.viewStacks[outletId];
        if (viewStack) {
            const viewItemToRemove = viewStack.find((x) => x.id === viewItem.id);
            if (viewItemToRemove) {
                viewItemToRemove.mount = false;
                this.viewStacks[outletId] = viewStack.filter((x) => x.id !== viewItemToRemove.id);
            }
        }
    }
    getStackIds() {
        return Object.keys(this.viewStacks);
    }
    getAllViewItems() {
        const keys = this.getStackIds();
        const viewItems = [];
        keys.forEach((k) => {
            viewItems.push(...this.viewStacks[k]);
        });
        return viewItems;
    }
}

const ids = { main: 0 };
const generateId = (type = "main") => {
    var _a;
    const id = ((_a = ids[type]) !== null && _a !== void 0 ? _a : 0) + 1;
    ids[type] = id;
    return id.toString();
};

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const useMenuController = (menuId) => {
    const element = document.body;
    const closedEventName = "puxDidClose";
    const [current, setCurrentMenu] = useState();
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        const menuDidOpen = () => {
            setIsOpen(true);
        };
        const menuDidClose = () => {
            setIsOpen(false);
        };
        const getMenus = () => __awaiter(void 0, void 0, void 0, function* () {
            const menus = yield menuController.getMenus();
            menus.map((menu) => {
                if (menu.getAttribute("menu-id") == menuId) {
                    setCurrentMenu(menu);
                }
            });
            if (current) {
                current.addEventListener("puxDidOpen", menuDidOpen);
                current.addEventListener("puxDidClose", menuDidClose);
            }
        });
        // Make sure element supports addEventListener
        const isSupported = element && element.addEventListener;
        if (!isSupported)
            return null;
        // Add event listener
        getMenus();
        // Remove event listener on cleanup
        return () => {
            if (current) {
                current.removeEventListener("puxDidOpen", menuDidOpen);
                current.removeEventListener("puxDidClose", menuDidClose);
            }
        };
    }, [closedEventName, element, menuId, current] // Re-run if eventName or element changes
    );
    return {
        current,
        isOpen,
    };
};

export { ByteFormat, DateFormat, LocationHistory, NavManager, PriceFormat, PuxActionSheet, PuxAlert, PuxDialogue, PuxDialogueLocationAware, PuxErrorBoundary, PuxLoading, PuxModal, PuxModalButton, PuxModalFooter, PuxModalLocation, PuxPopover, PuxRedirect, PuxRoute, PuxRouterContext, PuxRouterOutlet, PuxTabs, PuxTabsContext, PuxToast, PuxToastGlobal, PuxTypography, RouteManagerContext, ViewLifeCycleManager, ViewStacks, formatDate, generateId, i18nFormater, initializeI18n, puxGlobalEventName, setIntlOptions, toaster, useBreakpoint, useBreakpoints, useMenuController, usePuxActionSheet, usePuxAlert, usePuxLoading, usePuxLocationAwereness, usePuxModal, usePuxPopover, usePuxRouter, usePuxToast, useResourceBundles };
//# sourceMappingURL=index.esm.js.map
